import React, { useEffect, useRef, useState } from 'react';
import { ExitToApp } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { getService } from 'reducers/service';
import { useSelector } from 'react-redux';
import { reportNameMapper } from './reportDataProcessingHelper';

const DownloadCSV = ({ ReportID, filters }) => {
  const service = getService('ssrs-csv');
  const userAgency = useSelector((state) => state.user.userAgency);
  const csvRef = useRef(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const reportingOfficer = useSelector((state) => state.user?.userData?.user?.FullName);

  useEffect(() => {
    if (dataLoaded && csvRef.current) {
      csvRef.current.link.click();
      setDataLoaded(false);
    }
  }, [dataLoaded]);
  const getData = async () => {
    try {
      setDataLoaded(false);
      setLoading(true);
      const data = { ...filters, ReportingOfficer: reportingOfficer, AgencyId: userAgency };

      const res = await service.get(ReportID, { query: { ...data } });
      res.forEach((dataset, index) => {
        const baseName = reportNameMapper(ReportID);
        const fileName = res.length > 1 ? `${baseName}_${index + 1}.csv` : `${baseName}.csv`;
        downloadCSV(dataset, fileName);
      });
    } finally {
      setDataLoaded(true);
      setLoading(false);
    }
  };

  const downloadCSV = (data, fileName) => {
    const csvLink = document.createElement('a');

    const headers = Object.keys(data[0] || {}).join(',');
    const rows = data.map((row) => Object.values(row).join(',')).join('\n');

    const csvContent = `${headers}\n${rows}`;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    csvLink.href = URL.createObjectURL(blob);
    csvLink.download = fileName;
    csvLink.click();

    URL.revokeObjectURL(csvLink.href);
  };

  return (
    <>
      <IconButton disabled={loading} color="secondary" title="Export to CSV" onClick={getData}>
        <ExitToApp fontSize="large" style={{ backgroundColor: 'transparent' }} />
      </IconButton>
    </>
  );
};

export default DownloadCSV;
